import React from 'react'
import { t } from 'ttag'
import PropTypes from 'prop-types'

const InstitutionInfo = ({ item }) => {
  //console.log(item)
  const tuition = () => {
    const tuition = item.relevantInfo?.charges

    if (tuition) {
      const _tuitionAmt = tuition.isInState
        ? tuition.inStateTuition
        : tuition.outOfStateTuition
      const tuitionIsEqual = tuition.inStateTuition == tuition.outOfStateTuition
      const tuitionAmt = _tuitionAmt?.toLocaleString('en-US', {
        style: 'currency',
        minimumFractionDigits: 0,
        currency: 'USD'
      })
      const inStateDesc = tuition.isInState && !tuitionIsEqual ? t`In State` : ``

      if (tuitionAmt) {
        return (
          <div className="personalization-item">
            <i className="fal fa-usd-circle"></i>{' '}
            <span className="hidden-xs">{t`Annual ${inStateDesc} Tuition:`}</span>{' '}
            {tuitionAmt}
          </div>
        )
      }

      return null
    }

    return null
  }
  const totalEnrollment = () => {
    if (item.relevantInfo?.enrollment?.attendenceStatus) {
      const totalFormatted = item.relevantInfo.enrollment?.attendenceStatus?.total?.toLocaleString()

      return (
        <div className="personalization-item">
          <i className="fal fa-graduation-cap"></i>{' '}
          <span className="hidden-xs">{t`Enrollment:`}</span> {totalFormatted}
        </div>
      )
    }

    return null
  }
  const admissions = () => {
    let returnElements = []

    if (item.relevantInfo.admissions?.policy == 'open') {
      returnElements = [
        ...returnElements,
        <div className="personalization-item" key="open-admission-pi">
          <i className="fal fa-university"></i> {t`Open admission`}
        </div>
      ]
    } else {
      if (item.relevantInfo.admissions?.totalAcceptance) {
        let speed = ''

        if (item.relevantInfo.admissions.totalAcceptance > 80) {
          speed = `-fastest`
        } else if (item.relevantInfo.admissions.totalAcceptance > 60) {
          speed = `-fast`
        } else if (item.relevantInfo.admissions.totalAcceptance < 10) {
          speed = `-slowest`
        } else if (item.relevantInfo.admissions.totalAcceptance < 20) {
          speed = `-slow`
        }

        returnElements = [
          ...returnElements,
          <div className="personalization-item" key="acceptance-rate-pi">
            <i className={`fal fa-tachometer${speed}`}></i>{' '}
            <span className="hidden-xs">{t`Acceptance Rate:`}</span>{' '}
            {item.relevantInfo.admissions.totalAcceptance}%
          </div>
        ]
      }

      if (item.relevantInfo.admissions?.act) {
        returnElements = [
          ...returnElements,
          <div className="personalization-item" key="scores-pi">
            <i className="fal fa-pencil-ruler"></i> {t`ACT:`}{' '}
            {item.relevantInfo.admissions.act.min} -{' '}
            {item.relevantInfo.admissions.act.max}
          </div>
        ]
      }

      if (item.relevantInfo.admissions?.sat) {
        returnElements = [
          ...returnElements,
          <div className="personalization-item" key="admissions-pi">
            <i className="fal fa-pencil-ruler"></i> {t`SAT:`}{' '}
            {item.relevantInfo.admissions.sat.min} -{' '}
            {item.relevantInfo.admissions.sat.max}
          </div>
        ]
      }
    }

    // console.log("ITMS", returnElements)
    return returnElements.length > 0 ? returnElements : null
  }

  return (
    <div className="personalization-holder">
      {totalEnrollment()}
      {tuition()}
      {admissions()}
    </div>
  )
}

InstitutionInfo.propTypes = {
  item: PropTypes.object
}
export { InstitutionInfo }
